/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: GCI 2020
  Author: Dtsmart
  Author URL: http://dtsmart.vn
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import SideBarRight from './components/SideBarRight.vue'
import ItemCheckin from './components/checkout/ItemCheckin.vue'
import SideBarItem from './components/SideBarItem.vue'
import CheckoutHistoryPopup from './components/checkout/CheckoutHistoryPopup.vue'
import HistoryServiceDetail from './components/checkout/HistoryServiceDetail.vue'
import PopupInfo from './components/checkout/PopupInfo.vue'
import PopupInfoNewVer from './components/checkout/PopupInfoNewVer.vue'
import AutoCheckoutPopup from './components/checkout/AutoCheckoutPopup.vue'
import ListItem from './components/checkout/ListItem.vue'
import ListRadioItem from './components/checkout/ListRadioItem.vue'
import CheckoutList from './components/checkout/CheckoutList.vue'
import CheckoutGrid from './components/checkout/CheckoutGrid.vue'
import PopupStaffServiceDetail from './components/checkout/PopupStaffServiceDetail.vue'
import PopupPromotion from './components/checkout/PopupPromotion.vue'
import PopupRedemtion from './components/checkout/PopupRedemtion.vue'
import PopupService from './components/checkout/PopupService.vue'
import PopupTip from './components/checkout/PopupTip.vue'
import ViewInvoice from './components/checkout/ViewInvoice.vue'
import PopupStaff from './components/checkout/PopupStaff.vue'
import PopupUpdateStaff from './components/checkout/PopupUpdateStaff.vue'
import CheckoutPromotion from './components/checkout/CheckoutPromotion.vue'
import CheckoutRedeem from './components/checkout/CheckoutRedeem.vue'
import CalculatorButton from './components/checkout/CalculatorButton.vue'
import AppointmentTabs from './components/checkout/AppointmentTabs.vue'
import CustomSpinner from './components/CustomSpinner.vue'
import CallInfoPopup from './components/CallInfoPopup.vue'
import OTPVerificationPrompt from './components/OTPVerificationPrompt.vue'

import BusinessBlockTime from './components/apppointment/BusinessBlockTime.vue'
import StaffBlockTime from './components/apppointment/StaffBlockTime.vue'
import AddTimeOff from './components/apppointment/AddTimeOff.vue'
import UpdateTimeOff from './components/apppointment/UpdateTimeOff.vue'

import PopupCheckIn from './components/checkin/PopupCheckIn'

import UpdateCustomer from './components/customer/UpdateCustomer.vue'
import UpdateCustomerGroup from './components/customer/UpdateCustomerGroup.vue'
import CustomerChart from './components/customer/CustomerChart.vue'
import CustomerHistory from './components/customer/CustomerHistory.vue'
import CustomerPopupContent from './components/customer/CustomerPopupContent.vue'

import UpdateStaff from './components/staff/UpdateStaff.vue'
import AddStaff from './components/staff/AddStaff.vue'
import StaffItem from './components/staff/StaffItem.vue'
import StaffContent from './components/staff/StaffContent.vue'
import WorkingHour from './components/staff/WorkingHour.vue'
import StaffInfo from './components/staff/StaffInfo.vue'
import StaffService from './components/staff/StaffService.vue'

import ConfigurationContent from './components/staff/ConfigurationContent.vue'
import CommissionContent from './components/staff/CommissionContent.vue'
import SalaryCommissionContent from './components/staff/SalaryCommissionContent.vue'
import SalaryContent from './components/staff/SalaryContent.vue'
import AddCommissionContent from './components/staff/AddCommissionContent.vue'
import AddSalaryCommissionContent from './components/staff/AddSalaryCommissionContent.vue'
import AddSalaryContent from './components/staff/AddSalaryContent.vue'
import CommissionSetting from './components/staff/CommissionSetting.vue'

import UpdateCategory from './components/services/UpdateCategory.vue'
import UpdateServices from './components/services/UpdateServices.vue'
import AddCategory from './components/services/AddCategory.vue'
import AddService from './components/services/AddService.vue'
import CategoryItem from './components/services/CategoryItem.vue'
import ServiceContent from './components/services/ServiceContent.vue'
import ProductContent from './components/services/ProductContent.vue'
import ComboContent from './components/services/ComboContent.vue'
import GiftCardContent from './components/services/GiftCardContent.vue'
import CreateGiftcardPopup from './components/services/CreateGiftcardPopup.vue'
import ImportGiftcardFormPopup from './components/services/ImportGiftcardFormPopup.vue'
import CustomContent from './components/services/CustomContent.vue'
import AddProduct from './components/services/AddProduct.vue'
import UpdateProduct from './components/services/UpdateProduct.vue'
import AddCombo from './components/services/AddCombo.vue'
import UpdateCombo from './components/services/UpdateCombo.vue'
import PopupAddItem from './components/services/PopupAddItem.vue'
import RedemptionHistory from './components/services/RedemptionHistory.vue'

import AddPromotion from './components/promotions/AddPromotion.vue'
import PromotionListExpired from './components/promotions/PromotionListExpired.vue'
import PromotionList from './components/promotions/PromotionList.vue'
import UpdateReminder from './components/promotions/UpdateReminder.vue'
import UpdateBirthday from './components/promotions/UpdateBirthday.vue'
import UpdateNewClient from './components/promotions/UpdateNewClient.vue'

import SurveyReview from './components/review/reviewSetting/SurveyReview.vue'
import GoogleReview from './components/review/reviewSetting/GoogleReview.vue'
import StaffRatingSetting from './components/review/reviewSetting/StaffRatingSetting.vue'
import StaffRatingDevicePopup from './components/review/reviewSetting/StaffRatingDevicePopup.vue'
import ItemGoogleReview from './components/review/reviewList/ItemGoogleReview.vue'
import ItemYelpReview from './components/review/reviewList/ItemYelpReview.vue'
import ItemGoCheckinReview from './components/review/reviewList/ItemGoCheckinReview.vue'
import GoogleReviewContent from './components/review/reviewList/GoogleReviewContent.vue'
import YelpReviewContent from './components/review/reviewList/YelpReviewContent.vue'
import GoCheckinReviewContent from './components/review/reviewList/GoCheckinReviewContent.vue'
import AllReviewContent from './components/review/reviewList/AllReviewContent.vue'
import PopupDetail from './components/review/reviewList/PopupDetail.vue'
import DetailContent from './components/review/reviewList/DetailContent.vue'
import ReplyFeedback from './components/review/reviewList/ReplyFeedback.vue'

import AddReward from './components/reward/AddReward.vue'
import UpdateReward from './components/reward/UpdateReward.vue'

import ServiceStaffSetting from './components/AppSetting/ServiceStaffSetting.vue'
import TicketSetting from './components/AppSetting/TicketSetting.vue'
import CheckoutSetting from './components/AppSetting/CheckoutSetting.vue'
import ChangePassword from './components/AppSetting/ChangePassword.vue'
import Profile from './components/AppSetting/Profile.vue'
import TermAndPolicy from './components/AppSetting/TermAndPolicy.vue'
import BusinessWordHour from './components/AppSetting/BusinessWorkHour.vue'
import AppointmentSettingActive from './components/AppSetting/AppointmentSettingActive.vue'
import AppointmentSMSContent from './components/AppSetting/AppointmentSMSContent.vue'
import AppointmentActivePrice from './components/AppSetting/AppointmentActivePrice.vue'
import OrderSetting from './components/AppSetting/OrderSetting.vue'
import SkipOwnerConfirmation from './components/AppSetting/SkipOwnerConfirmation.vue'
import TaxSetting from './components/AppSetting/TaxSetting.vue'
import StandalonePaxMode from './components/AppSetting/StandalonePaxMode.vue'
import StaffReceipt from './components/AppSetting/StaffReceipt.vue'
import CashDiscountMode from './components/AppSetting/CashDiscountMode.vue'
import Surcharge from './components/AppSetting/Surcharge.vue'
import GCIStationLanguage from './components/AppSetting/GCIStationLanguage.vue'
import TipOnDevice from './components/AppSetting/TipOnDevice.vue'
import PrintOnCloverSetting from './components/AppSetting/PrintOnCloverSetting.vue'
import ServiceFee from './components/AppSetting/ServiceFee.vue'
import StoreRatingOnGCIApp from './components/AppSetting/StoreRatingOnGCIApp.vue'
import SMSCountSetting from './components/AppSetting/SMSCountSetting.vue'
import SMSCountTab from './components/AppSetting/SMSCountTab.vue'
import SMSRechargeTab from './components/AppSetting/SMSRechargeTab.vue'
import AddCardPopup from './components/AppSetting/AddCardPopup.vue'
import QRCodeSetting from './components/AppSetting/QRCodeSetting.vue'
import FlexCheckinSetting from './components/AppSetting/FlexCheckinSetting.vue'

import CheckoutAppointment  from './components/CheckoutAppointment.vue'

import ViewNotify from './components/NotificationApp/ViewNotify.vue'
import ViewCallHistory from './components/NotificationApp/ViewCallHistory.vue'

import MyButton from './components/MyButton.vue'
import CustomPagination from './components/CustomPagination.vue'
import MyCalculator from './components/MyCalculator.vue'
import MyStaffItem from './components/MyStaffItem.vue'
import VxTooltipCustom from './components/VxTooltipCustom.vue'
import ProgressBarCustom from './components/ProgressBarCustom.vue'
import vSelect from 'vue-select'
import DashboardLineChart from './components/DashboardLineChart.vue'

import VueMask from 'v-mask'
import AvatarCropper from './components/staff/AvatarCropper.vue'

import EditItemOrder from './components/order/EditItemInOrder.vue'
import OrderInvoice from './components/order/OrderInvoice.vue'

import SignaturePopup from './components/checkout/SignaturePopup.vue'

import AddArticle from './components/article/AddArticle.vue'
import ImageArticle from './components/article/ImageArticle.vue'

import TimeKeepingComponent from './components/gopos/TimeKeepingComponent.vue'
import LogComponent from './components/gopos/LogComponent.vue'
import AddTimeKeeping from './components/gopos/addTimeKeeping.vue'
import UpdateTimeKeeping from './components/gopos/updateTimeKeeping.vue'
import POSStaffPopup from './components/gopos/POSStaffPopup.vue'
import EditStoreSidebar from './components/gopos/EditStoreSidebar.vue'
import OrderDetailPopup from './components/gopos/OrderDetailPopup.vue'
import UpdateOrderPopup from './components/gopos/UpdateOrderPopup.vue'
import UpdateOrderStaffPopup from './components/gopos/UpdateOrderStaffPopup.vue'
import UpdatePricePopup from './components/gopos/UpdatePricePopup.vue'
import CreateCustomItemPopup from './components/gopos/CreateCustomItemPopup.vue'
import UpdateOrderGiftCardContent from './components/gopos/UpdateOrderGiftCardContent.vue'

import popupSettingPayroll from './components/gopos/popupSettingPayroll.vue'
import SalaryChartPopup from './components/gopos/SalaryChartPopup.vue'
import CreatePayrollPopup from './components/gopos/CreatePayrollPopup.vue'
import ConfirmPayrollPopup from './components/gopos/ConfirmPayrollPopup.vue'
import PayrollComponent from './components/gopos/PayrollComponent.vue'
import PayrollDetailComponent from './components/gopos/PayrollDetailComponent.vue'
import PayrollEditStaffSidebar from './components/gopos/PayrollEditStaffSidebar.vue'
import UpdateCommissionContent from './components/gopos/UpdateCommissionContent.vue'
import UpdateSalaryCommissionContent from './components/gopos/UpdateSalaryCommissionContent.vue'
import UpdateSalaryContent from './components/gopos/UpdateSalaryContent.vue'
import CustomLoading from './components/gopos/CustomLoading.vue'


Vue.use(VueMask);

Vue.component(BusinessBlockTime.name, BusinessBlockTime)
Vue.component(StaffBlockTime.name, StaffBlockTime)
Vue.component(AddTimeOff.name, AddTimeOff)
Vue.component(UpdateTimeOff.name, UpdateTimeOff)

Vue.component(AddArticle.name, AddArticle)
Vue.component(ImageArticle.name, ImageArticle)

Vue.component(PopupCheckIn.name ,PopupCheckIn)

Vue.component(EditItemOrder.name, EditItemOrder)

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(SideBarRight.name, SideBarRight)
Vue.component(ItemCheckin.name, ItemCheckin)
Vue.component(SideBarItem.name, SideBarItem)
Vue.component(CheckoutHistoryPopup.name, CheckoutHistoryPopup)
Vue.component(HistoryServiceDetail.name, HistoryServiceDetail)
Vue.component(PopupInfo.name, PopupInfo)
Vue.component(PopupInfoNewVer.name, PopupInfoNewVer)
Vue.component(AutoCheckoutPopup.name, AutoCheckoutPopup)
Vue.component(ListItem.name, ListItem)
Vue.component(ListRadioItem.name, ListRadioItem)
Vue.component(CheckoutList.name, CheckoutList)
Vue.component(CheckoutGrid.name, CheckoutGrid)
Vue.component(PopupStaffServiceDetail.name, PopupStaffServiceDetail)
Vue.component(PopupPromotion.name, PopupPromotion)
Vue.component(PopupRedemtion.name, PopupRedemtion)
Vue.component(PopupService.name, PopupService)
Vue.component(PopupTip.name, PopupTip)
Vue.component(ViewInvoice.name, ViewInvoice)
Vue.component(PopupStaff.name, PopupStaff)
Vue.component(PopupUpdateStaff.name, PopupUpdateStaff)
Vue.component(CheckoutPromotion.name, CheckoutPromotion)
Vue.component(CheckoutRedeem.name, CheckoutRedeem)
Vue.component(CalculatorButton.name, CalculatorButton)
Vue.component(AppointmentTabs.name, AppointmentTabs)
Vue.component(CustomSpinner.name, CustomSpinner)
Vue.component(CallInfoPopup.name, CallInfoPopup)
Vue.component(OTPVerificationPrompt.name, OTPVerificationPrompt)

Vue.component(UpdateCustomer.name, UpdateCustomer)
Vue.component(UpdateCustomerGroup.name, UpdateCustomerGroup)
Vue.component(CustomerChart.name, CustomerChart)
Vue.component(CustomerHistory.name, CustomerHistory)
Vue.component(CustomerPopupContent.name, CustomerPopupContent)

Vue.component(UpdateStaff.name, UpdateStaff)
Vue.component(AddStaff.name, AddStaff)
Vue.component(StaffItem.name, StaffItem)
Vue.component(StaffContent.name, StaffContent)
Vue.component(WorkingHour.name, WorkingHour)
Vue.component(StaffInfo.name, StaffInfo)
Vue.component(StaffService.name, StaffService)
Vue.component(ConfigurationContent.name, ConfigurationContent)
Vue.component(CommissionContent.name, CommissionContent)
Vue.component(SalaryCommissionContent.name, SalaryCommissionContent)
Vue.component(SalaryContent.name, SalaryContent)
Vue.component(AddCommissionContent.name, AddCommissionContent)
Vue.component(AddSalaryCommissionContent.name, AddSalaryCommissionContent)
Vue.component(AddSalaryContent.name, AddSalaryContent)
Vue.component(CommissionSetting.name, CommissionSetting)

Vue.component(UpdateCategory.name, UpdateCategory)
Vue.component(UpdateServices.name, UpdateServices)
Vue.component(AddCategory.name, AddCategory)
Vue.component(AddService.name, AddService)
Vue.component(CategoryItem.name, CategoryItem)
Vue.component(ServiceContent.name, ServiceContent)
Vue.component(ProductContent.name, ProductContent)
Vue.component(ComboContent.name, ComboContent)
Vue.component(GiftCardContent.name, GiftCardContent)
Vue.component(CreateGiftcardPopup.name, CreateGiftcardPopup)
Vue.component(ImportGiftcardFormPopup.name, ImportGiftcardFormPopup)
Vue.component(CustomContent.name, CustomContent)
Vue.component(AddProduct.name, AddProduct)
Vue.component(UpdateProduct.name, UpdateProduct)
Vue.component(AddCombo.name, AddCombo)
Vue.component(UpdateCombo.name, UpdateCombo)
Vue.component(PopupAddItem.name, PopupAddItem)
Vue.component(RedemptionHistory.name, RedemptionHistory)

Vue.component(ViewNotify.name, ViewNotify)
Vue.component(ViewCallHistory.name, ViewCallHistory)

Vue.component(AddPromotion.name, AddPromotion)
Vue.component(PromotionListExpired.name, PromotionListExpired)
Vue.component(PromotionList.name, PromotionList)
Vue.component(UpdateReminder.name, UpdateReminder)
Vue.component(UpdateBirthday.name, UpdateBirthday)
Vue.component(UpdateNewClient.name, UpdateNewClient)

Vue.component(SurveyReview.name, SurveyReview)
Vue.component(GoogleReview.name, GoogleReview)
Vue.component(StaffRatingSetting.name, StaffRatingSetting)
Vue.component(StaffRatingDevicePopup.name, StaffRatingDevicePopup)
Vue.component(ItemGoogleReview.name, ItemGoogleReview)
Vue.component(ItemYelpReview.name, ItemYelpReview)
Vue.component(ItemGoCheckinReview.name, ItemGoCheckinReview)
Vue.component(GoogleReviewContent.name, GoogleReviewContent)
Vue.component(YelpReviewContent.name, YelpReviewContent)
Vue.component(GoCheckinReviewContent.name, GoCheckinReviewContent)
Vue.component(AllReviewContent.name, AllReviewContent)
Vue.component(PopupDetail.name, PopupDetail)
Vue.component(DetailContent.name, DetailContent)
Vue.component(ReplyFeedback.name ,ReplyFeedback)

Vue.component(AddReward.name, AddReward)
Vue.component(UpdateReward.name, UpdateReward)

Vue.component(MyButton.name, MyButton)
Vue.component(CustomPagination.name, CustomPagination)
Vue.component(MyStaffItem.name, MyStaffItem)
Vue.component(VxTooltipCustom.name, VxTooltipCustom)
Vue.component(ProgressBarCustom.name, ProgressBarCustom)
Vue.component(CheckoutAppointment.name, CheckoutAppointment)
Vue.component(DashboardLineChart.name, DashboardLineChart)

Vue.component(ServiceStaffSetting.name, ServiceStaffSetting)
Vue.component(TicketSetting.name, TicketSetting)
Vue.component(CheckoutSetting.name, CheckoutSetting)
Vue.component(ChangePassword.name, ChangePassword)
Vue.component(Profile.name, Profile)
Vue.component(TermAndPolicy.name, TermAndPolicy)
Vue.component(BusinessWordHour.name, BusinessWordHour)
Vue.component(AppointmentSettingActive.name, AppointmentSettingActive)
Vue.component(AppointmentSMSContent.name, AppointmentSMSContent)
Vue.component(AppointmentActivePrice.name, AppointmentActivePrice)
Vue.component(OrderSetting.name, OrderSetting)
Vue.component(SkipOwnerConfirmation.name, SkipOwnerConfirmation)
Vue.component(TaxSetting.name, TaxSetting)
Vue.component(StandalonePaxMode.name, StandalonePaxMode)
Vue.component(StaffReceipt.name, StaffReceipt)
Vue.component(CashDiscountMode.name, CashDiscountMode)
Vue.component(Surcharge.name, Surcharge)
Vue.component(GCIStationLanguage.name, GCIStationLanguage)
Vue.component(TipOnDevice.name, TipOnDevice)
Vue.component(PrintOnCloverSetting.name, PrintOnCloverSetting)
Vue.component(ServiceFee.name, ServiceFee)
Vue.component(StoreRatingOnGCIApp.name, StoreRatingOnGCIApp)
Vue.component(SMSCountSetting.name, SMSCountSetting)
Vue.component(SMSCountTab.name, SMSCountTab)
Vue.component(SMSRechargeTab.name, SMSRechargeTab)
Vue.component(AddCardPopup.name, AddCardPopup)
Vue.component(QRCodeSetting.name, QRCodeSetting)
Vue.component(FlexCheckinSetting.name, FlexCheckinSetting)

Vue.component(AvatarCropper.name, AvatarCropper)
Vue.component(MyCalculator.name, MyCalculator)
Vue.component(OrderInvoice.name, OrderInvoice)
Vue.component(SignaturePopup.name, SignaturePopup)

Vue.component(TimeKeepingComponent.name, TimeKeepingComponent)
Vue.component(LogComponent.name, LogComponent)
Vue.component(AddTimeKeeping.name, AddTimeKeeping)
Vue.component(UpdateTimeKeeping.name, UpdateTimeKeeping)
Vue.component(POSStaffPopup.name, POSStaffPopup)
Vue.component(EditStoreSidebar.name, EditStoreSidebar)
Vue.component(OrderDetailPopup.name, OrderDetailPopup)
Vue.component(UpdateOrderPopup.name, UpdateOrderPopup)
Vue.component(UpdateOrderStaffPopup.name, UpdateOrderStaffPopup)
Vue.component(UpdatePricePopup.name, UpdatePricePopup)
Vue.component(CreateCustomItemPopup.name, CreateCustomItemPopup)
Vue.component(UpdateOrderGiftCardContent.name, UpdateOrderGiftCardContent)

Vue.component(popupSettingPayroll.name, popupSettingPayroll)
Vue.component(SalaryChartPopup.name, SalaryChartPopup)
Vue.component(CreatePayrollPopup.name, CreatePayrollPopup)
Vue.component(ConfirmPayrollPopup.name, ConfirmPayrollPopup)
Vue.component(PayrollComponent.name, PayrollComponent)
Vue.component(PayrollDetailComponent.name, PayrollDetailComponent)
Vue.component(PayrollEditStaffSidebar.name, PayrollEditStaffSidebar)
Vue.component(UpdateCommissionContent.name, UpdateCommissionContent)
Vue.component(UpdateSalaryCommissionContent.name, UpdateSalaryCommissionContent)
Vue.component(UpdateSalaryContent.name, UpdateSalaryContent)
Vue.component(CustomLoading.name, CustomLoading)

// v-select component

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)
